export default __webpack_public_path__ + "static/media/star-background.22630e4f.jpg";